import { BG_STYLES, COMMON_STYLES, TEXT_STYLES, TYPOGRAPHY, VARIANTS_STYLES } from "@dehaat/dds";
import { ROLE_MAP } from "app/constants/request";
import ApproveIcon from "app/icons/Approve";
import { ROUTES } from "app/routes/types";
import { ROLE_TYPES, RoleType } from "app/store/reducer/requestflow";
import { rnNavigation } from "app/utils/appConfig";
import { logout } from "app/utils/common";
import React from "react";
import { Modal, Pressable, StyleSheet, Text, View } from "react-native";

type DropdownProps = {
  showDropdown: boolean;
  setShowDropdown: (show: boolean) => void;
  data: string[];
  selectedRole: string;
  setSelectedRole: (role: string) => void;
};
const Dropdown = ({
  showDropdown,
  setShowDropdown,
  data,
  selectedRole,
  setSelectedRole,
}: DropdownProps) => {
    
  return (
    <Modal
      visible={showDropdown}
      transparent
      animationType="fade"
      onRequestClose={() => setShowDropdown(false)}
    >
      <View
        style={[
          styles.dropdownOverlay,
          COMMON_STYLES.flex1,
          COMMON_STYLES.justifyStart,
          COMMON_STYLES.alignItemsEnd,
        ]}
      >
        <Pressable
          onPress={() => setShowDropdown(false)}
          style={StyleSheet.absoluteFillObject}
        />
        <View
          style={[
            BG_STYLES.bgNeutral00,
            COMMON_STYLES['br1/2'],
            COMMON_STYLES.ph1,
            styles.dropdown,
          ]}
        >
          {data.map((role, index) => (
            <Pressable
              key={index}
              onPress={() => {
                setSelectedRole(role)
                localStorage.setItem('UserRole', role)
                setShowDropdown(false)
                if (ROLE_TYPES.includes(role as RoleType)) {
                  rnNavigation({ name: ROUTES.REQUEST_TYPE })
                }
              }}
              style={[
                COMMON_STYLES['pv3/8'],
                COMMON_STYLES.row,
                COMMON_STYLES.alignItemsCenter,
                styles.gap2,
              ]}
            >
              {selectedRole === role && <ApproveIcon width={16} height={16} />}
              <Text
                style={[
                  TYPOGRAPHY.TEXT2,
                  VARIANTS_STYLES.BASE,
                  selectedRole === role
                    ? TEXT_STYLES.textPrimary100
                    : TEXT_STYLES.textNeutral80,
                ]}
              >
                {ROLE_MAP[role] || role}
              </Text>
            </Pressable>
          ))}
          <Pressable
            onPress={async () => {
              setShowDropdown(false)
              await logout()
            }}
            style={COMMON_STYLES['pv3/8']}
          >
            <Text style={TEXT_STYLES.textPrimary100}>Logout</Text>
          </Pressable>
        </View>
      </View>
    </Modal>
  )
};

export default Dropdown;
const styles = StyleSheet.create({
  dropdownOverlay: {
    backgroundColor: 'rgba(0,0,0,0.1)',
    paddingTop: 60,
    paddingRight: 40,
  },
  dropdown: {
    paddingVertical: 10,
    elevation: 5,
    minWidth: 180,
  },
  image: {
    borderRadius: 99,
    width: 32,
    height: 32,
  },
  gap2: {
    gap: 2,
  },
})